import Header from './components/Header';
import Hero from './components/Hero';
import FAQSection from './components/FAQSection';
import CarouselSection from './components/CarouselSection';
import UpdatesSection from './components/UpdatesSection';
import CardsSection from './components/CardsSection';
import AboutSection from './components/AboutSection';
import TopicsSection from './components/TopicsSection';
import MediaSection from './components/MediaSection';
import CommentsSection from './components/CommentsSection';
import AppSection from './components/AppSection';
import RankingSection from './components/RankingSection';
import IndexSection from './components/IndexSection';
import FeaturesSection from './components/FeaturesSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-100">
      <Header />
      <main>
        <Hero />
        <FAQSection />
        <CarouselSection />
        <UpdatesSection />
        <CardsSection />
        <AboutSection />
        <TopicsSection />
        <MediaSection />
        <CommentsSection />
        <AppSection />
        <RankingSection />
        <IndexSection />
        <FeaturesSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}